export class OptionVariation {
    id: number = 0;
    imageVariationURL: string = "";
    nomVariation: string = "";
    prix: number = 0;
    produitId: number = 0;
}